export default __webpack_public_path__ + "static/media/total-amount-settled.f99de056.svg";